export default "/images/vendor/@coreui/icons/svg/flag/cif-ro.svg?6ab2b3a040d00205ff92edb52f52be13";